import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://wfrgyttqkzhdisveubpu.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indmcmd5dHRxa3poZGlzdmV1YnB1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM2OTE2NjYsImV4cCI6MjA3OTI2NzY2Nn0.Uc7V2HVpRHrVvxaaSl0HvS9kwPDxH1_kOulxqSOOUxM'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)